import React, {Component, PropTypes} from "react";
import {connect} from "react-redux";
import {
    GetOneInterfaceLang,
    ChangeInterfaceLang,
    getInterfaceTranslation,
    GetInterfaceLang,
    addInterfaceTranslation,
    getInterfaceFilter,
    editInterfaceTranslation
} from "../../actions/index";
import {Link} from "react-router";


class InterfaceLanguageEdit extends Component {
    static contextTypes = {
        router: PropTypes.object,
        fields: PropTypes.object
    };
    constructor(props){
        super(props);
        this.state={
            active: false
        }
        this.closeModal = this.closeModal.bind(this);
        this.deactivate = this.deactivate.bind(this);
        this.activateLang = this.activateLang.bind(this);
        this.changeInput = this.changeInput.bind(this);
        this.AddLangFromModal = this.AddLangFromModal.bind(this);
        this.filterInput = this.filterInput.bind(this);
        this.submitTranslation = this.submitTranslation.bind(this);
    }
    componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        this.props.GetOneInterfaceLang(token, this.props.params.id);
        this.props.getInterfaceTranslation(token);
        this.props.GetInterfaceLang(token);
    }
    componentDidMount(){
        $('.selectpicker').selectpicker();
    }
    componentDidUpdate(){
        $('.selectpicker').selectpicker();
    }
    componentWillUnmount(){
        this.props.lang.interface_one = {}
    }
    deactivate(param){
        this.setState({
            active: param
        });
        $('#Deactivate').modal('show');
    }
    closeModal(id){
        $('#'+id).modal('hide');
    }
    activateLang(param){
        let token = localStorage.getItem('id_token_admin');
        let obj = {
            is_active: param
        };
        this.props.ChangeInterfaceLang(token, obj, this.props.params.id).then((response)=>{
            if(response.payload.status == '200'){
                this.props.GetOneInterfaceLang(token, this.props.params.id);
                $('#Deactivate').modal('hide');
            }
        });
    }
    addElement(){
        $('#AddLang').modal('show');
    }
    filterInput(e){
        let token = localStorage.getItem('id_token_admin');
        let data = {
            search : $('input[name="word"]').val(),
            blang : $('input[name="blang"]').val(),
            woblang: $('select[name="woblang"]').val() != 'selectDefault' ? $('select[name="woblang"]').val() : ''
        }
        this.props.getInterfaceFilter(token, data);
        $('.selectpicker').selectpicker('refresh');
    }
    AddLangFromModal(){
        let token = localStorage.getItem('id_token_admin');
        if($('#select_element').val() != ''){
            if($('#translation_element').val() != ''){
                let arr = [];
                let obj = {
                    blang: this.props.params.id,
                    translation: $('#translation_element').val()
                }
                arr.push(obj);
                let data = {
                    key: $('#select_element').val(),
                    translations: arr
                }
                this.props.addInterfaceTranslation(token, data).then((response)=>{
                    $('#AddLang').modal('hide');
                    this.props.getInterfaceTranslation(token);
                    $('#select_element').val('');
                    $('#translation_element').val('');
                })
            }else{
                $('#translation_element').parent().addClass('has-error');
            }
        }else{
            $('#select_element').parent().addClass('has-error');
        }

    }
    changeInput(e){
        this.setState({
            [e.target.name]: e.target.value
        });
        $(e.target).parent().removeClass('has-error');
    }

    submitTranslation(){
        let token = localStorage.getItem('id_token_admin');
        let that = this;
        for(let i = 0; i < $('.block_input').length; i++) {
            let oneBlock = $('.block_input')[i];
            if ($(oneBlock).find('input').val() == '') {
                $(oneBlock).find('input').parent().addClass('has-error');
            }
        }
        if($('.formsBlock').find('.has-error').length > 0){
            return false
        }else{
            for(let i = 0; i < $('.block_input').length; i++){
                let oneBlock = $('.block_input')[i];
                if($(oneBlock).find('input').data('value') != $(oneBlock).find('input').val()){
                    let arr = [];
                    let obj = {
                        blang: that.props.params.id,
                        translation:$(oneBlock).find('input').val()
                    };
                    arr.push(obj);
                    let data = {
                        key: $(oneBlock).find('label').text(),
                        translations: arr
                    };
                    that.props.editInterfaceTranslation(token, data, $(oneBlock).find('label').data('id'));
                }
            }
            that.context.router.push('/language/interface/');
        }
    }
    renderInputs(item, i){
        let trans = item.translations.filter((e)=>{return e.blang==this.props.params.id})
        if(trans.length){
            let obj = trans[0];
            return (
                <input type="text"
                       id={obj.blang + i}
                       name={obj.blang + i}
                       data-value={obj.translation}
                       value={this.state[obj.blang+ i] || obj.translation}
                       className="form-control"
                       onChange={this.changeInput}
                />
            )
        }else{
            return(
                <input type="text"
                       id={this.props.params.id+i}
                       name={this.props.params.id+i}
                       data-value=''
                       value={this.state[this.props.params.id+ i]}
                       className="form-control"
                       onChange={this.changeInput}
                />
            )
        }
    }
    renderTranslate(){
        return this.props.lang.interface_translation.results.map((item, i)=>{
            return(
                <div className="row block_input"  key={i}>
                    <div className="col-md-offset-1 col-md-3">
                        <label data-id={item.id}>{item.key}</label>
                    </div>
                    <div className="col-md-6">
                        {this.renderInputs(item, i)}
                    </div>
                </div>
            )
        })
    }
    render() {
        return (
            <div className="dashboard-wrapper">
                <div className="dashboard-title clearfix">
                    <div className="dib">
                        <p className="dashboard-title">{this.props.lang.interface_one && this.props.lang.interface_one.lang ? this.props.lang.interface_one.lang.name : ''}</p>
                        <p className="dashboard-text">Interface Languages</p>
                    </div>
                    <div className="dib pull-right">
                        {this.props.lang.interface_one && this.props.lang.interface_one.is_active ?
                            <button onClick={this.deactivate.bind(this, true)} type="button" className="pull-right btn btn-danger">
                                Deactivate language
                            </button>
                            :
                            <button onClick={this.deactivate.bind(this, false)} type="button" className="pull-right btn btn-success">
                                Activate language
                            </button>
                        }
                    </div>

                </div>
                <div className="col-md-12">
                    <div className="white-block">
                        <div className="clearfix">
                            <input type="text" name="blang" value={this.props.params.id} hidden="hidden" onChange={this.filterInput}/>
                            <div className="col-md-4">
                                <div className=" input-group search_block">
                                    <span className="input-group-addon glyphicon glyphicon-search"></span>
                                    <input type="text" name="word" className="form-control" placeholder="Search" onChange={this.filterInput}/>
                                </div>
                            </div>
                            <div className="col-md-8">
                                <div className="input-half pull-left mr20">
                                    {this.props.lang.interface_one.lang && this.props.lang.interface_one ?
                                        <select className="selectpicker" name="woblang" id="Without" defaultValue="selectDefault" data-live-search="true" onChange={this.filterInput}>
                                            <option value="selectDefault">All</option>
                                            <option value={this.props.lang.interface_one.id}>Without translation</option>
                                        </select>
                                        :""}
                                </div>
                                <div className="pull-right">
                                    <button onClick={this.addElement} type="button" className="pull-right btn btn-primary">
                                        <span className="glyphicon glyphicon-plus" aria-hidden="true"></span>
                                        Add element
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="delimiter"></div>
                        <div className="formsBlock">
                            {this.props.lang.interface_translation.results && this.props.lang.interface_translation.results.length > 0 ? this.renderTranslate() : <p className="noResults">No items result</p> }
                        </div>
                        {this.props.lang.interface_translation.results && this.props.lang.interface_translation.results.length > 0 ?
                            <div className="for_btn">
                                <Link to="language/interface" className="btn btn-default">Back</Link>
                                <button type="button" className="btn btn-primary" onClick={this.submitTranslation}>Save</button>
                            </div>
                            :""}
                    </div>
                </div>

                <div className="modal fade" id="Deactivate" tabIndex="-1" role="dialog" aria-labelledby="DeactivateLabel">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" onClick={this.closeModal.bind(this, 'Deactivate')} aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            </div>
                            <div className="modal-body text-center">
                                <span className="glyphicon glyphicon-alert" aria-hidden="true" data-toggle="modal" data-target="#Deactivate"></span>
                                <p>Do you really want to {this.state.active ? 'deactivate' : 'activate'} this language?</p>
                                <input type="text" hidden="hidden" id="for_id"/>
                            </div>
                            <div className="modal-footer text-center">
                                <button onClick={this.closeModal.bind(this, 'Deactivate')} type="button" className="btn btn-default">No</button>
                                <button onClick={this.activateLang.bind(this, !this.state.active)} type="button" className="btn btn-primary">Yes</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="AddLang" tabIndex="-1" role="dialog" aria-labelledby="AddLangLabel">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" onClick={this.closeModal.bind(this, 'AddLang')} aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <p className="title">Add element</p>
                            </div>
                            <div className="modal-body text-center">
                                <div className="mb10">
                                    <label htmlFor="select_element">Name element</label>
                                    <input type="text" id="select_element" className="form-control" placeholder="Name" onChange={this.changeInput}/>
                                </div>
                                <div>
                                    <label htmlFor="translation_element">Translation element</label>
                                    <input type="text" id="translation_element" className="form-control" placeholder="Translation" onChange={this.changeInput}/>
                                </div>
                            </div>
                            <div className="modal-footer text-center">
                                <button onClick={this.closeModal.bind(this, 'AddLang')} type="button" className="btn btn-default">Cancel</button>
                                <button onClick={this.AddLangFromModal} type="button" className="btn btn-primary">Add</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="clearfix"></div>
            </div>
        );
    }
}

function  mapStateToProps(state) {
    return{
        lang: state.lang
    }
}
export default connect(mapStateToProps, {GetOneInterfaceLang, ChangeInterfaceLang, getInterfaceTranslation, GetInterfaceLang, addInterfaceTranslation, getInterfaceFilter, editInterfaceTranslation})(InterfaceLanguageEdit);


// WEBPACK FOOTER //
// ./src/components/language/interfaceEdit.js